// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class CitiesComparisonTable extends BasicReactTableWrapper {
  suffix(column) {
    if (column.Header !== "5-Year CAGR") { return; }

    return "%";
  }
}

CitiesComparisonTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default CitiesComparisonTable;
